import sliderLoader from '../../vively/scripts/utils/slider-loader';
import stickybits from 'stickybits';
import $ from 'jquery';
import 'bootstrap';

const Articles = () => {
  if (!window.route || !/^articles\//.test(window.route)) {
    return;
  }

  // Sliders
  sliderLoader({
    slider: '.slider-single',
    settings: {
      autoplaySpeed: 3000,
      slidesToShow: 1,
      autoplay: true,
      arrows: false,
      dots: true,
      rows: 0
    }
  });

  // Floating elements
  const $articleContent = $('.article-content');
  if ($articleContent.length) {
    stickybits('.sticky-element', { stickyBitStickyOffset: 20 });

    const buttons = $('#share-buttons');
    const $icons = buttons.find('.sticky-element');
    const $img = $articleContent.find('img').first();

    const decideShareHeight = () => {
      const isRow = getComputedStyle($icons[0]).flexDirection === 'row';
      const iconHeight = $icons.children().first().height();

      buttons.css('top', isRow
        ? ($img.height() - iconHeight * 2)
        : 0
      );
    };

    // Adjusting share menu
    $(window).resize(decideShareHeight);
    decideShareHeight();
  }

  const $newsletterModal = $('#newsletter-modal');
  if ($newsletterModal.length) {
    setTimeout(() => $newsletterModal.modal('show'), 25000);
  }
};

export default Articles;




// WEBPACK FOOTER //
// ./articles/scripts/main.js